<template>
  <component
    :is="componentForm.component"
    v-if="hasForm"
  />
</template>

<script>
export default {
  name: 'NewsSection',
  data: () => ({
    componentName: '',
  }),
  computed: {
    hasForm() {
      return !!this.componentName;
    },
    componentForm() {
      if (!this.hasForm) return null;

      return {
        component: () => import(`@/components/News/${this.componentName}.vue`),
      };
    },
  },
};
</script>
